<div class="standings scrollTable scrollTable" #sLeftContainer style="height:calc(100vh - 185px);"
  (scroll)="standingsScroll($event)">
  <div class="headers">
    <ng-container *ngFor="let header of contest?.data?.standing_header?.columns">
      <div [ngClass]="header.class">{{header.name}}</div>
    </ng-container>
  </div>
  <div class="loading" *ngIf="standingsLoading">
    <img src="assets/images/loading.gif">
  </div>
  <div class="sRow" [ngClass]="{'myTeam':lgm.user_id == user.id}" *ngFor="let lgm of standings">
    <ng-container *ngFor="let header of contest?.data?.standing_header?.columns">
      <div [ngClass]="header.class" *ngIf="header.class == 'name'" (click)="loadContest(lgm.slug)">{{ (lgm[header.field])
        ?
        lgm[header?.field] : "" }}
      </div>
      <div [ngClass]="header.class" *ngIf="header.class != 'name'">{{ (lgm[header.field]) ? lgm[header.field] : 0 |
        number:'1.0-2'}}
        {{(header?.class == 'rank' && lgm?.is_tie == 'Y')?'*':''}}
      </div>
      </ng-container>
  </div>
</div>